import type { Supabase } from '~/types/supabase-client';
import TableService from './table.service';

export class PlayersService extends TableService<'players'> {
  constructor(supabase: Supabase) {
    super(supabase, 'players', {
      pk: 'id',
      defaultSort: { field: 'id', ascending: false, nullsFirst: true },
    });
  }
}
